export const eliminationConstantFromIteration = (i) => Math.log(2) / (0.5 + 0.01 * i);

export const computeCmaxFirstDose = (dose, infusionTime, volumeOfDistribution, eliminationConstant) => {
  const tinf = parseFloat(infusionTime);
  const ke = parseFloat(eliminationConstant);
  const vd = parseFloat(volumeOfDistribution);
  const parsedDose = parseFloat(dose);

  return (parsedDose / (vd * ke * tinf)) * (1. - Math.exp(-ke * tinf));
};

export const computeConcentrationFirstDoseAt = (
  dose,
  infusionTime,
  volumeOfDistribution,
  eliminationConstant,
  timeFromInfusionStart
) => {
  const tinf = parseFloat(infusionTime);
  const ke = parseFloat(eliminationConstant);
  const x = parseFloat(timeFromInfusionStart);
  const cmax = computeCmaxFirstDose(dose, tinf, volumeOfDistribution, ke);

  return cmax * Math.exp(-ke * (x - tinf));
};

export const computeCmaxSteadyState = (
  dose,
  infusionTime,
  volumeOfDistribution,
  eliminationConstant,
  doseInterval
) => {
  const tinf = parseFloat(infusionTime);
  const ke = parseFloat(eliminationConstant);
  const tau = parseFloat(doseInterval);
  const cmaxFirstDose = computeCmaxFirstDose(dose, tinf, volumeOfDistribution, ke);

  return cmaxFirstDose / (1. - Math.exp(-ke * tau));
};

export const computeCminSteadyState = (
  dose,
  infusionTime,
  volumeOfDistribution,
  eliminationConstant,
  doseInterval
) => {
  const tinf = parseFloat(infusionTime);
  const ke = parseFloat(eliminationConstant);
  const tau = parseFloat(doseInterval);
  const cmax = computeCmaxSteadyState(dose, tinf, volumeOfDistribution, ke, tau);

  return cmax * Math.exp(-ke * (tau - tinf));
};

export const computeConcentrationSteadyStateAt = (
  dose,
  infusionTime,
  volumeOfDistribution,
  eliminationConstant,
  doseInterval,
  timeFromInfusionStart
) => {
  const tinf = parseFloat(infusionTime);
  const ke = parseFloat(eliminationConstant);
  const x = parseFloat(timeFromInfusionStart);
  const cmax = computeCmaxSteadyState(dose, tinf, volumeOfDistribution, ke, doseInterval);

  return cmax * Math.exp(-ke * (x - tinf));
};
